import { Fragment, jsx, jsxs } from "@ecopages/jsx/jsx-runtime";
import "./tree.script";
const TreeNodes = ({
  nodes
}) => /* @__PURE__ */jsx(Fragment, {
  children: nodes.map(node => /* @__PURE__ */jsx("li", {
    class: "rui-tree__item",
    children: node.children?.length ? /* @__PURE__ */jsxs(Fragment, {
      children: [/* @__PURE__ */jsx("button", {
        type: "button",
        class: "rui-tree__node",
        role: "treeitem",
        "data-value": node.id,
        "aria-expanded": node.expanded ?? false,
        "aria-selected": "false",
        tabindex: -1,
        children: node.label
      }), /* @__PURE__ */jsx("ul", {
        role: "group",
        children: /* @__PURE__ */jsx(TreeNodes, {
          nodes: node.children
        })
      })]
    }) : /* @__PURE__ */jsx("button", {
      type: "button",
      class: "rui-tree__node",
      role: "treeitem",
      "data-value": node.id,
      "aria-selected": "false",
      tabindex: -1,
      children: node.label
    })
  }))
});
export function RuiTree({
  nodes,
  label,
  children,
  ...props
}) {
  const content = nodes != null ? /* @__PURE__ */jsx(TreeNodes, {
    nodes
  }) : children;
  return /* @__PURE__ */jsx("rui-tree", {
    ...props,
    label,
    children: /* @__PURE__ */jsx("ul", {
      class: "rui-tree",
      "data-ref": "root",
      role: "tree",
      "aria-label": label || void 0,
      "aria-multiselectable": "false",
      children: content
    })
  });
}